export var cardSelectorPortalTokens = {
  borderWidth: 2,
  focusBoxShadowParams: "0 0 3px 1px",
  focusColor: function focusColor(_ref) {
    var color = _ref.color;
    return color.border.focus.base;
  },
  colors: {
    bgBase: function bgBase(_ref2) {
      var palette = _ref2.palette;
      return palette.neutralsBlack.hex5;
    },
    bgBaseHover: function bgBaseHover(_ref3) {
      var palette = _ref3.palette;
      return palette.neutralsBlack.hex8;
    },
    bgSelected: function bgSelected(_ref4) {
      var palette = _ref4.palette;
      return palette.neutralsBlack.hex5;
    },
    bgSelectedHover: function bgSelectedHover(_ref5) {
      var palette = _ref5.palette;
      return palette.neutralsBlack.hex8;
    },
    border: function border(_ref6) {
      var color = _ref6.color;
      return color.border.focus.base;
    }
  },
  sizes: {
    m: {
      radius: 10,
      paddings: 16,
      siblingMargin: 8
    },
    l: {
      radius: 16,
      paddings: 24,
      siblingMargin: 16
    }
  }
};